"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTransChain = addTransChain;
exports.transAllStr2Text = transAllStr2Text;
exports.ele2VNode = ele2VNode;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _transText = require("../json2view/transText");

var _action = require("./action");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transFunctions = [];

function addTransChain(func) {
  transFunctions.push(func);
}

function transAllStr2Text(obj, data) {
  if (!obj || !data) {
    return obj;
  }

  if (typeof obj === 'string') {
    return (0, _transText.transText)(obj, data);
  }

  if ((0, _typeof2.default)(obj) !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(function (o) {
      return transAllStr2Text(o, data);
    });
  }

  var out = {};
  Object.keys(obj).forEach(function (key) {
    out[key] = transAllStr2Text(obj[key], data);
  });
  return out;
}

function transPropsAndAttrsAndOn(ele, data) {
  var tag = ele.tag,
      children = ele.children,
      className = ele.className,
      style = ele.style,
      _ele$props = ele.props,
      props = _ele$props === void 0 ? {} : _ele$props,
      _ele$attrs = ele.attrs,
      attrs = _ele$attrs === void 0 ? {} : _ele$attrs,
      _ele$domProps = ele.domProps,
      domProps = _ele$domProps === void 0 ? {} : _ele$domProps,
      on = ele.on,
      nativeOn = ele.nativeOn,
      directives = ele.directives,
      scopedSlots = ele.scopedSlots,
      slot = ele.slot,
      key = ele.key,
      ref = ele.ref,
      refInFor = ele.refInFor,
      rest = (0, _objectWithoutProperties2.default)(ele, ["tag", "children", "className", "style", "props", "attrs", "domProps", "on", "nativeOn", "directives", "scopedSlots", "slot", "key", "ref", "refInFor"]);
  var result = transAllStr2Text(rest, data);
  var newOn = {};
  Object.keys(result).forEach(function (key) {
    if (key.length > 2 && key.substr(0, 2) === 'on') {
      var firstWord = key.charAt(2).toLowerCase();
      var name = firstWord + key.substr(3);
      var otherParams = result[key];

      var func = function func() {
        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return (0, _action.action)(_objectSpread(_objectSpread({
          action: name
        }, otherParams), params));
      };

      newOn[name] = func;
      result[key] = func;
    }
  });
  return {
    tag: tag,
    'class': className,
    style: style,
    props: _objectSpread(_objectSpread({}, props), result),
    attrs: _objectSpread(_objectSpread({}, attrs), result),
    domProps: _objectSpread(_objectSpread({}, domProps), result),
    on: _objectSpread(_objectSpread({}, on), newOn),
    nativeOn: nativeOn,
    directives: directives,
    scopedSlots: scopedSlots,
    slot: slot,
    key: key,
    ref: ref,
    refInFor: refInFor,
    children: children,
    data: data
  };
}

function ele2VNode(h, ele, data) {
  // ele 为空
  if (!ele) {
    return undefined;
  } // ele 是 string


  if (typeof ele === 'string') {
    return (0, _transText.transText)(ele, data);
  } // ele 是数组


  if ((0, _typeof2.default)(ele) === 'object' && Array.isArray(ele)) {
    return ele.map(function (e) {
      return ele2VNode(h, e, data);
    });
  } // ele 是 IElementData
  // 调用转化链


  transFunctions.forEach(function (func) {
    if (!ele) {
      return;
    }

    ele = func(ele, data);
  });

  if (!ele) {
    return;
  }

  var _transPropsAndAttrsAn = transPropsAndAttrsAndOn(ele, data),
      tag = _transPropsAndAttrsAn.tag,
      children = _transPropsAndAttrsAn.children,
      rest = (0, _objectWithoutProperties2.default)(_transPropsAndAttrsAn, ["tag", "children"]); // children转数组


  var childNode = ele2VNode(h, children, data);

  if ((0, _typeof2.default)(childNode) === 'object' && !Array.isArray(childNode)) {
    childNode = [childNode];
  }

  return h(tag, rest, childNode);
}